export default () => [
  {
    field: "seq",
    width: 50,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "saveStatus",
    align: "center",
    width: 100,
    title: "导入状态",
    slots: { default: "status" },
  },
  {
    field: 'errorMsg',
    align: 'left',
    headerAlign: 'center',
    title: '导入异常原因',
    width: 200,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: "vehicleSortInfo",
    width: 100,
    align: "center",
    title: "车辆序号",
  },
  // {
  //   headerAlign: 'center',
  //   field: 'vehicleNo',
  //   align: 'center',
  //   minWidth: 120,
  //   title: '车牌号',
  //   fixed: 'left',
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  // },
  {
    field: 'vehicleNo',
    title: '车牌号',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleModelName',
    align: 'center',
    minWidth: 120,
    title: '车型',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleLicenseTypeName',
    align: 'center',
    minWidth: 120,
    title: '车牌类型',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleBrandName',
    align: 'left',
    minWidth: 120,
    title: '车辆品牌',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleLicense',
    align: 'left',
    minWidth: 120,
    title: '车辆行驶证号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleLicenseValidity',
    align: 'center',
    minWidth: 150,
    title: '车辆行驶证有效期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'purchaseDate',
    align: 'center',
    minWidth: 120,
    title: '购车日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'vehicleVolume',
    align: 'center',
    minWidth: 120,
    title: '体积',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleLengthName',
    align: 'center',
    minWidth: 120,
    title: '车长（米）',
    sortable: true,
    // sortType: 'number',
    // slots: {
    //   default: 'vehicleLengthDefault',
    // },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleLoad',
    align: 'center',
    minWidth: 120,
    title: '载重',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleLicenseValidityAlarmDays',
    align: 'center',
    minWidth: 150,
    title: '车辆行驶证到期提醒天数',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'registrationDate',
    align: 'center',
    minWidth: 120,
    title: '上牌日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'insuranceDate',
    align: 'center',
    minWidth: 120,
    title: '保险到期日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'inspectionDate',
    align: 'center',
    minWidth: 120,
    title: '年检到期日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'carrierName',
    align: 'left',
    minWidth: 200,
    title: '所属承运商',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'orgName',
    align: 'left',
    minWidth: 250,
    title: '登记机构',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'vehicleOwnerTypeName',
    align: 'left',
    minWidth: 200,
    title: '车辆归属',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'vehicleInspectionStatusName',
    align: 'center',
    minWidth: 100,
    title: '车辆审核状态',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'dataSourceName',
    align: 'center',
    width: 80,
    title: '数据来源',
  },
  {
    headerAlign: 'center',
    field: 'vehicleRemarks',
    align: 'left',
    minWidth: 300,
    title: '备注信息',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
];
